<template>
  <div class="code-bg">
    <div class="code-chart-area">
      <div
        ref="chartPanel"
        class="chart-panel chart-map-panel"
        v-loading="chartLoading"
        element-loading-text="加载中"
      >
        <ve-map
          :key="chartKey"
          :height="chartHeight"
          :data="chartData"
          :legend-visible="false"
          :settings="chartSettings"
          :visual-map="chartVisualMap"
          :events="chartEvents"
        ></ve-map>
      </div>
      <div
        class="chart-panel chart-bar-panel"
        v-loading="chartLoading"
        element-loading-text="加载中"
      >
        <ve-bar
          :key="chartKey"
          :height="chartHeight"
          width="100%"
          :data="barChartData"
          :settings="barChartSettings"
          :extend="barChartExtend"
          :colors="barColors"
          :textStyle="barTextStyle"
        ></ve-bar>
      </div>
    </div>
    <div class="code-filter-area">
      <div class="filter-row">
        <div class="filter-item filter-back">
          <el-button v-if="provinceFlag" type="primary" @click="reset()">返回上级</el-button>
        </div>
        <div class="filter-item filter-gtin">
          <el-input v-model="query.gtin" placeholder="请输入商品编号">
            <template slot="prepend">商品编号</template>
          </el-input>
        </div>
        <div class="filter-item filter-batch">
          <el-input v-model="query.batchNumber" placeholder="请输入批号">
            <template slot="prepend">批号</template>
          </el-input>
        </div>
        <div class="filter-actions">
          <el-button type="primary" :loading="chartLoading" @click="submit()">统计</el-button>
          <el-button @click="reset1()">重置</el-button>
        </div>
      </div>
      <div v-if="countTime" class="count-time-row">数据获取时间:{{ countTime }}</div>
    </div>
  </div>
</template>

<script>
import mapBg from "@/assets/image/mapbg.png";
import provinces from "../CodeAnalysis/provinces.json";
import transformation from "../CodeAnalysis/transformation.json";
import "echarts/lib/component/visualMap";
import api from "../../../util/extra-api";
import { formatTime } from "../../../util/util";

export default {
  components: {},
  data() {
    this.chartVisualMap = {
      min: 0,
      max: 1,
      show: true,
      left: 20,
      bottom: 20,
      text: ["High", "Low"],
      seriesIndex: [0],
      textStyle: {
        color: "#fff",
      },
      inRange: {
        color: ["#FFC809", "#F46E36"],
      },
      calculable: true,
    };
    this.chartEvents = {
      click: () => {},
      mapselectchanged: (v) => {
        const provinceName = this.provincesData[v.batch[0].name];
        if (provinceName) {
          this.chartSettings.position = `province/${provinceName}`;
          this.getDataCity(v.batch[0].name);
          this.provinceFlag = true;
        }
      },
    };
    this.barChartSettings = {
      labelMap: {
        total: "重量(kg)",
      },
      itemStyle: {
        normal: {
          label: {
            show: true, //开启显示
            position: "right", //在上方显示
            textStyle: {
              //数值样式
              color: "#fff",
              fontSize: 16,
            },
          },
        },
      },
    };
    // this.barLegend = {
    //   textStyle:{
    //     color:'#fff'
    //   }
    // }
    this.barTextStyle = {
      color: "#fff",
      fontSize: 13,
    };
    this.barChartExtend = {
      grid: {
        right: 60,
      },
      series: {
        type: "bar",
        barMaxWidth: "30",
      },
      legend: {
        textStyle: {
          color: "#fff",
        },
      },
      xAxis: {
        minInterval: 1,
      },
    };
    this.barColors = ["#04B9FF"];
    // this.tooltip = {
    //   trigger: "item",
    //   formatter(v) {
    //     console.log(v)
    //     if (v.data.value == undefined) {
    //       return "";
    //     } else {
    //       let str = `${v.name} <br/>${v.marker} ${v.seriesName} : ${v.data.value}`;
    //       return str;
    //     }
    //   }
    // };
    return {
      chartLoading: false,
      chartHeight: "650px",
      chartKey: 0,
      chartResizeObserver: null,
      companyId: null,
      cityName: "",
      provinceName: "",
      provincesData: {},
      transformation,
      chartData: {
        columns: ["位置", "重量(kg)"],
        rows: [],
      },
      barChartData: {
        columns: ["位置", "重量(kg)"],
        rows: [],
      },
      query: {
        gtin: "",
        batchNumber: "",
        province: "",
      },
      mapBg,
      timeRange: "",
      provinceFlag: false,
      countTime: "",
      chartSettings: {
        position: "china",
        selectedMode: "single",
        labelMap: {
          total: "重量(kg)",
        },
        label: {
          normal: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: 13,
            },
          },
          emphasis: {
            show: true,
            textStyle: {
              color: "#fff",
              fontSize: 13,
            },
          },
        },
        itemStyle: {
          normal: {
            areaColor: "transparent",
            borderColor: "rgba(147, 235, 248, 1)",
            borderWidth: 1,
            shadowColor: "rgba(128, 217, 248, 1)",
            shadowOffsetX: -2,
            shadowOffsetY: 2,
            shadowBlur: 10,
          },
          emphasis: {
            areaColor: "#04B9FF",
            shadowBlur: 10,
            shadowColor: "#fff",
          },
        },
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    getData(val) {
      if (!this.query.gtin) {
        this.chartData.rows = [];
        this.barChartData.rows = [];
        this.countTime = "";
        return;
      }
      this.query.province = val === 2 ? this.provinceName : "";
      let data = {
        gtin: this.query.gtin,
        batchNumber: this.query.batchNumber,
        province: this.query.province,
      };
      if (this.companyId) {
        data.companyId = this.companyId;
      }
      this.chartLoading = true;
      api
        .get("/v1/pc/scanCodeRecord/stockRegionChart", data)
        .then((response) => {
          const result = response.data && response.data.result ? response.data.result : [];
          this.chartData.columns = ["region", "total"];
          if (val === 1) {
            this.chartData.rows = result.map((m) => {
              const item = transformation.find((f) => f.name2 === m.region);
              return {
                region: item ? item.name1 : m.region,
                total: m.total,
              };
            });
          } else {
            this.chartData.rows = result;
          }
          this.barChartData.columns = ["region", "total"];
          this.barChartData.rows = result;
          this.chartVisualMap.max = response.data && response.data.max ? response.data.max : 1;
          this.countTime = formatTime(new Date(), "yyyy-MM-dd HH:mm:ss");
        })
        .finally(() => {
          this.chartLoading = false;
        });
    },

    // areaClick(data) {
    //   if (data in this.provincesData) {
    //     this.$nextTick(_ => {
    //       this.chartSettings.position = "province/" + this.provincesData[data];
    //       this.chartData = {
    //         columns: ["位置", "people"],
    //         rows: [{ 位置: "海淀区", people: 4123 }]
    //       };
    //     });
    //   }
    // }
    getDataCity(provinceName) {
      let province =
        transformation[
          transformation.findIndex((f) => f.name1 === provinceName)
        ].name2;
      this.provinceName = province;
      let data = { province: province };
      if (this.query.batchNumber) {
        data.batchNumber = this.query.batchNumber;
      }
      if (this.query.gtin) {
        data.gtin = this.query.gtin;
      }
      if (!this.query.gtin) {
        return;
      }
      if (this.companyId) {
        data.companyId = this.companyId;
      }
      api.get("/v1/pc/scanCodeRecord/stockRegionChart", data).then((response) => {
        // this.chartData.columns = ["region", "total"];
        // this.chartData.rows = response.data.result.map(m =>{
        //   return {
        //     region: transformation[transformation.findIndex(f => f.name2 === m.region)].name1,
        //     total: m.total
        //   }
        // });
        // this.barChartData.columns = ["region", "total"];
        // this.barChartData.rows = response.data.result;
        // case 2:
        let res = response.data && response.data.result ? response.data.result : [];
        // res.forEach(r => {
        //   r.city += "市"
        // });
        this.chartData.columns = ["region", "total"];
        this.chartData.rows = res;
        //   break;

        if (response.data.max) {
          this.chartVisualMap.max = response.data.max;
        } else {
          this.chartVisualMap.max = 1;
        }
        this.countTime = formatTime(new Date(), "yyyy-MM-dd HH:mm:ss");
      });
    },
    reset() {
      this.chartSettings.position = "china";
      this.getData(1);
      this.provinceFlag = false;
    },
    reset1() {
      this.query = {
        gtin: "",
        batchNumber: "",
        province: "",
      };
      this.timeRange = "";
      this.chartSettings.position = "china";
      this.chartData.rows = [];
      this.barChartData.rows = [];
      this.countTime = "";
      this.provinceFlag = false;
    },
    updateChartHeight() {
      this.$nextTick(() => {
        const chartPanelHeight = this.$refs.chartPanel ? this.$refs.chartPanel.clientHeight : 0;
        const nextHeight = `${Math.max(chartPanelHeight, 300)}px`;
        if (this.chartHeight !== nextHeight) {
          this.chartHeight = nextHeight;
          this.chartKey += 1;
        }
      });
    },
    submit() {
      if (!this.query.gtin) {
        this.$message.warning("请输入商品编号");
        return;
      }
      this.getData(!this.provinceFlag ? 1 : 2);
    },
  },
  created() {},
  mounted() {
    this.provincesData = provinces;
    if (localStorage.getItem("company_id")) {
      this.companyId = Number(localStorage.getItem("company_id"));
    }
    this.updateChartHeight();
    setTimeout(() => this.updateChartHeight(), 0);
    if (window.ResizeObserver) {
      this.chartResizeObserver = new ResizeObserver(() => this.updateChartHeight());
      this.chartResizeObserver.observe(this.$refs.chartPanel);
    }
    window.addEventListener("resize", this.updateChartHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateChartHeight);
    if (this.chartResizeObserver) {
      this.chartResizeObserver.disconnect();
    }
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin: 0 !important;
}
.code-bg {
  transform-origin: 0px 0px 0px;
  background-image: url("../../../assets/image/mapbg.png");
  background-size: cover;
  background-position: 50% 0;
  background-color: rgb(0, 0, 0);
  width: 100%;
  height: 100vh;
  padding: 10px 10px 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.code-chart-area {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(260px, 1fr);
  gap: 20px;
}
.chart-panel {
  height: 100%;
  min-height: 0;
  border: 2px solid rgba(0, 135, 255, 0.6);
  box-sizing: border-box;
  overflow: hidden;
}
.code-filter-area {
  flex-shrink: 0;
  padding: 14px 0 10px;
}
.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 15px;
}
.filter-item {
  flex: 0 0 auto;
}
.filter-back {
  width: 90px;
}
.filter-gtin {
  width: 420px;
  max-width: 100%;
}
.filter-batch {
  width: 260px;
}
.filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.filter-actions .el-button {
  margin-left: 0 !important;
}
.count-time-row {
  color: #fff;
  line-height: 28px;
  padding-left: 0;
}
@media (max-width: 900px) {
  .code-chart-area {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  .chart-bar-panel {
    display: none;
  }
}
</style>

